import produce from 'immer';
import { API_KEYS_ACTION } from './actions';

const initialState = {
  apiKeys: [],
  loading: false,
  type: '',
  createdApiKey: null, // Full API key shown only at creation
  error: null,
};

const ApiKeysManagement = (state = initialState, action) => {
  const { type: actionType, payload } = action;

  switch (actionType) {
    // Loading states
    case API_KEYS_ACTION.GET_API_KEYS:
    case API_KEYS_ACTION.CREATE_API_KEY:
    case API_KEYS_ACTION.UPDATE_API_KEY:
    case API_KEYS_ACTION.REVOKE_API_KEY:
    case API_KEYS_ACTION.DELETE_API_KEY:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = actionType;
        draft.error = null;
      });

    // Get API Keys Success
    case API_KEYS_ACTION.GET_API_KEYS_SUCCESS:
      return produce(state, (draft) => {
        draft.apiKeys = payload;
        draft.loading = false;
        draft.type = actionType;
      });

    // Create API Key Success
    case API_KEYS_ACTION.CREATE_API_KEY_SUCCESS:
      return produce(state, (draft) => {
        if (payload && payload.apiKey) {
          // Add new key to the list, filtering out any null entries
          const existingKeys = state.apiKeys.filter((key) => key != null);
          draft.apiKeys = [payload, ...existingKeys];
          draft.createdApiKey = payload.apiKey; // Store full key temporarily
        }
        draft.loading = false;
        draft.type = actionType;
      });

    // Update API Key Success
    case API_KEYS_ACTION.UPDATE_API_KEY_SUCCESS:
      return produce(state, (draft) => {
        draft.apiKeys = state.apiKeys
          .filter((key) => key != null)
          .map((key) =>
            key.apiKey === payload.apiKey ? { ...key, ...payload } : key
          );
        draft.loading = false;
        draft.type = actionType;
      });

    // Revoke API Key Success
    case API_KEYS_ACTION.REVOKE_API_KEY_SUCCESS:
      return produce(state, (draft) => {
        draft.apiKeys = state.apiKeys
          .filter((key) => key != null)
          .map((key) =>
            key.apiKey === payload.apiKey
              ? { ...key, isActive: false, revokedAt: payload.revokedAt }
              : key
          );
        draft.loading = false;
        draft.type = actionType;
      });

    // Delete API Key Success
    case API_KEYS_ACTION.DELETE_API_KEY_SUCCESS:
      return produce(state, (draft) => {
        draft.apiKeys = state.apiKeys.filter(
          (key) => key != null && key.apiKey !== payload.apiKey
        );
        draft.loading = false;
        draft.type = actionType;
      });

    // Error states
    case API_KEYS_ACTION.GET_API_KEYS_ERROR:
    case API_KEYS_ACTION.CREATE_API_KEY_ERROR:
    case API_KEYS_ACTION.UPDATE_API_KEY_ERROR:
    case API_KEYS_ACTION.REVOKE_API_KEY_ERROR:
    case API_KEYS_ACTION.DELETE_API_KEY_ERROR:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
        draft.error = payload;
      });

    // Clean states
    case API_KEYS_ACTION.CREATE_API_KEY_CLEAN_STATE:
    case API_KEYS_ACTION.UPDATE_API_KEY_CLEAN_STATE:
    case API_KEYS_ACTION.REVOKE_API_KEY_CLEAN_STATE:
    case API_KEYS_ACTION.DELETE_API_KEY_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
      });

    // Clear created key (after user closes modal)
    case API_KEYS_ACTION.CLEAR_CREATED_KEY:
      return produce(state, (draft) => {
        draft.createdApiKey = null;
        draft.type = actionType;
      });

    default:
      return state;
  }
};

export default ApiKeysManagement;
